export const CTA_TITLE = `בקשה לפרעון מוקדם מלא או חלקי של הלוואת משכנתא`;
export const CTA_TEXT = `לתשומת לבך, הגשת בקשה לפירעון מוקדם מלא או חלקי, כרוכה בהפקת מסמכים הנושאת עלות נוספת לפי תעריפון החברה`;
export const PART_TO_REPLACE = `לתשומת לבך`;

export const WHATSAPP = `Whatsapp`;
export const CONTACT_NUMBER = `054-7109227`;
